import { readLocal, saveLocal } from "./localStorageHelper";
import {CONSTANTS} from "../ressources/CONSTANTS";

export const saveSession = (s) => saveLocal(`crescendo-${CONSTANTS.VERSION}-session`, s);
export const getSession = () => readLocal(`crescendo-${CONSTANTS.VERSION}-session`, null);
